import moment from "moment";

export const RECEIVED_DATE_HEADER = "Received date";

export const formatReceivedDate = (date) => (
  date ? moment(date, ["YYYY-MM-DD", "DD/MM/YYYY"], true).format("DD/MM/YYYY") : "-"
);

export const buildExportHeaders = ({
  tableHeaders,
  testsColumnLabel,
  finalResultColumnLabel,
  includeReceivedDate,
}) => {
  const headers = [...tableHeaders];

  if (includeReceivedDate && !headers.includes(RECEIVED_DATE_HEADER)) {
    const sampleIdIndex = headers.indexOf("Sample ID");
    headers.splice(sampleIdIndex >= 0 ? sampleIdIndex + 1 : 1, 0, RECEIVED_DATE_HEADER);
  }

  headers.push(testsColumnLabel);

  if (finalResultColumnLabel) {
    headers.push(finalResultColumnLabel);
  }

  return headers;
};

export const buildExportRow = (row, {
  tableHeaders,
  includeReceivedDate,
  finalResultColumnLabel,
}) => {
  const cells = [];

  tableHeaders.forEach((header) => {
    if (header === "Sample ID") {
      cells.push(row.sample_id);
    } else if (header === RECEIVED_DATE_HEADER) {
      cells.push(formatReceivedDate(row.received_date));
    } else if (header === "Sample Type") {
      cells.push(row.sample_type);
    }
  });

  if (includeReceivedDate && !tableHeaders.includes(RECEIVED_DATE_HEADER)) {
    cells.splice(1, 0, formatReceivedDate(row.received_date));
  }

  cells.push(row.tests);

  if (finalResultColumnLabel) {
    cells.push(row.final_result);
  }

  return cells;
};
